module.exports = __webpack_public_path__ + "img/starthouse_bodyimage05.b9d31d2a.jpg";